import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/Magazine.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { FaDownload, FaArrowRight } from "react-icons/fa";
import CoverImg from "../../images/cover-sample-magazine-placeholder.png";

const API_BASE = "https://college-website-backend-316h.onrender.com";

export default function Magazine() {
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMagazines();
  }, []);

  const fetchMagazines = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/magazines`);

      // IMPORTANT: safely extract array
      const magazineList =
        Array.isArray(res.data) ? res.data :
        Array.isArray(res.data.magazines) ? res.data.magazines :
        Array.isArray(res.data.data) ? res.data.data :
        [];

      setMagazines(magazineList);
    } catch (error) {
      console.error("Error fetching magazines:", error);
    } finally {
      setLoading(false);
    }
  };

  const latestMagazine = magazines[0];
  const previousEditions = magazines.slice(1);

  return (
    <>
      <Navbar />

      <div className="magazine-page fade-in-page">
        <h1 className="magazine-title">📚 College Magazine Archive</h1>

        {loading && <p style={{ textAlign: "center" }}>Loading magazines...</p>}

        {!loading && magazines.length === 0 && (
          <p style={{ textAlign: "center" }}>No magazines available.</p>
        )}

        {/* ⭐ Latest Edition */}
        {!loading && latestMagazine && (
          <section>
            <h2 className="section-title">⭐ Latest Edition</h2>

            <div className="featured-mag-card slide-up">
              <img
                src={CoverImg}
                alt="Magazine Cover"
                className="featured-cover"
              />

              <div className="featured-content">
                <h3>{latestMagazine.title}</h3>
                <p className="featured-year">
                  Issue: {latestMagazine.issue}
                </p>

                <a
                  href={latestMagazine.pdfUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="download-btn"
                >
                  <FaDownload /> View / Download
                </a>
              </div>
            </div>
          </section>
        )}

        {/* 📖 Previous Editions */}
        {!loading && previousEditions.length > 0 && (
          <section>
            <h2 className="section-title">📖 Previous Editions</h2>

            <div className="magazine-grid">
              {previousEditions.map((mag) => (
                <div className="mag-card slide-up" key={mag._id}>
                  <img
                    src={CoverImg}
                    alt="Magazine Cover"
                    className="mag-cover"
                  />

                  <div className="mag-info">
                    <h3>{mag.title}</h3>
                    <p className="mag-year">{mag.issue}</p>

                    <a
                      href={mag.pdfUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="view-btn"
                    >
                      View PDF <FaArrowRight />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>

      <Footer />
    </>
  );
}
